import { useEffect, useState } from 'react';
import { apiClientWithMiddleware } from '../api/utils';
import Raven from 'raven-js';
import { getPortalId } from '../utils/getPortalId';
const useGetAlertData = () => {
  const [alerts, setAlerts] = useState([]);
  const portalId = getPortalId();
  useEffect(() => {
    const path = `/navconfig/v2/alerts?portalId=${portalId}`;
    const clientConfig = {
      maxRetries: 5
    };
    apiClientWithMiddleware(clientConfig).get(path).then(res => {
      setAlerts(res);
    }).catch(err => {
      Raven.captureException(err);
    });
  }, [portalId]);
  return alerts;
};
export default useGetAlertData;